/**
 * SF-4758: product priorities pages. The limits mirror the sf-api priorities API, which checks
 * every one again; the UI only refuses bad input before a call.
 */

/** Refine resource for the Priorities menu (App.tsx and the menu test share it). */
export const PRIORITIES_RESOURCE = { name: 'priorities', list: '/priorities' } as const;

/** How many items one person may rank (N): the product rule is 3..20, default 10. */
export const TOP_N_MIN = 3;
export const TOP_N_MAX = 20;

/** Team and person weights: the product rule is 0..10, decimals allowed. */
export const WEIGHT_MIN = 0;
export const WEIGHT_MAX = 10;
/** The team weights form steps in halves, as the ticket asks; typed decimals still save. */
export const WEIGHT_STEP = 0.5;

/** Item field lengths, the same caps POST/PATCH /items enforce on sf-api. */
export const ITEM_TITLE_MAX = 120;
export const ITEM_DESCRIPTION_MAX = 2000;
/** SF-5087: the caps sf-api puts on an item's Jira tickets and on its companies. */
export const JIRA_KEYS_MAX = 10;
export const COMPANIES_MAX = 20;

/** SF-5080: list field lengths, the same caps POST/PATCH /lists enforce on sf-api. */
export const LIST_NAME_MAX = 60;
export const LIST_DESCRIPTION_MAX = 500;

/** SF-5080: how each list status reads on the page. */
export const LIST_STATUS_LABELS = {
  voting: 'Open for voting',
  hidden: 'Not open',
  archived: 'Archived',
} as const;
